export const UPDATE_GENERAL_PROPERTY = 'UPDATE_GENERAL_PROPERTY';

export const UPDATE_CHANGE_TRACK_PROPERTY = 'UPDATE_CHANGE_TRACK_PROPERTY';

export const UPDATE_FETCHED_VALUE = 'UPDATE_FETCHED_VALUE';

export const UPDATE_GENERAL_FETCHED_VALUE = 'UPDATE_GENERAL_FETCHED_VALUE';

export const UPDATE_ATTRIBUTE_TABLE_FETCHED_VALUE = 'UPDATE_ATTRIBUTE_TABLE_FETCHED_VALUE';

export const UPDATE_ACTION_TABLE_FETCHED_VALUE = 'UPDATE_ACTION_TABLE_FETCHED_VALUE';

export const TOGGLE_CREATE_ACTION_DIALOG = 'TOGGLE_CREATE_ACTION_DIALOG';

export const ADD_NEW_ACTION = 'ADD_NEW_ACTION';

export const SET_ACTION_TABLE_ACTIONS = 'SET_ACTION_TABLE_ACTIONS';

export const TOGGLE_EXPAND_ACTION = 'TOGGLE_EXPAND_ACTION';

export const DELETE_ACTION = 'DELETE_ACTION';

export const TOGGLE_UPDATE_ACTION_DIALOG = 'TOGGLE_UPDATE_ACTION_DIALOG';

export const UPDATE_ACTION = 'UPDATE_ACTION';

export const SET_ATTRIBUTE_TABLE_ATTRIBUTES = 'SET_ATTRIBUTE_TABLE_ATTRIBUTES';

export const TOGGLE_SELECT_ATTRIBUTE_DIALOG = 'TOGGLE_SELECT_ATTRIBUTE_DIALOG';

export const TOGGLE_SYNC_ATTRIBUTE_DIALOG = 'TOGGLE_SYNC_ATTRIBUTE_DIALOG';

export const TOGGLE_ATTRIBUTE_HYPERLINK = 'TOGGLE_ATTRIBUTE_HYPERLINK';

export const SELECT_ATTRIBUTE = 'SELECT_ATTRIBUTE';

export const SET_SYNCED_COMPONENTS_CHANGED = 'SET_SYNCED_COMPONENTS_CHANGED';

export const SET_ATTRIBUTE_TARGET_PAGE = 'SET_ATTRIBUTE_TARGET_PAGE';

export const SET_ATTRIBUTE_PROPERTY = 'SET_ATTRIBUTE_PROPERTY';

export const SET_REFERENCES = 'SET_REFERENCES';

export const SELECT_REFERENCE = 'SELECT_REFERENCE';

export const ADD_REFERENCE_ROW = 'ADD_REFERENCE_ROW';

export const UPDATE_REFERENCE_PROPERTY = 'UPDATE_REFERENCE_PROPERTY';

export const DELETE_REFERENCE = 'DELETE_REFERENCE';

export const RESET_CONTEXT = 'RESET_CONTEXT';

export const TOGGLE_SAVING = 'TOGGLE_SAVING';

export const TOGGLE_PUBLISHING = 'TOGGLE_PUBLISHING';

export const SET_STEPS = 'SET_STEPS'

export const SELECTED_STEP_ID = 'SELECTED_STEP_ID';

export const SET_FORM_ACTIONS = 'SET_FORM_ACTIONS';

export const UPDATE_FORM_ACTION = 'UPDATE_FORM_ACTION';

export const ADD_STEP = 'ADD_STEP';

export const REMOVE_STEP = 'REMOVE_STEP';

export const REMOVE_MULTIPLE_STEPS = 'REMOVE_MULTIPLE_STEPS';

export const UPDATE_STEP_NAME = 'UPDATE_STEP_NAME';

export const UPDATE_STEP_LANGUAGES = 'UPDATE_STEP_LANGUAGES';

export const ADD_COLUMN = 'ADD_COLUMN';

export const REMOVE_COLUMN = 'REMOVE_COLUMN';

export const TOGGLE_COLUMN_HYPERLINK = 'TOGGLE_COLUMN_HYPERLINK';

export const TOGGLE_COLUMN_COLOR_FORMATTING = 'TOGGLE_COLUMN_COLOR_FORMATTING';

export const DROP_COLUMN_IN_SAME_SECTION = 'DROP_COLUMN_IN_SAME_SECTION';

export const DROP_COLUMN_IN_DIFFERENT_SECTION = 'DROP_COLUMN_IN_DIFFERENT_SECTION';

export const RESIZE_COLUMNS = 'RESIZE_COLUMNS';

export const ADD_SECTION = 'ADD_SECTION';

export const REMOVE_SECTION = 'REMOVE_SECTION';

export const MOVE_SECTION_UP = 'MOVE_SECTION_UP';

export const MOVE_SECTION_DOWN = 'MOVE_SECTION_DOWN';

export const UPDATE_SECTION_NAME = 'UPDATE_SECTION_NAME';

export const UPDATE_SECTION_LANGUAGES = 'UPDATE_SECTION_LANGUAGES';

export const UPDATE_LAYOUT_FROM_RECOMMENDATION = 'UPDATE_LAYOUT_FROM_RECOMMENDATION';